var map = {
	"./01.png": 5824,
	"./02.png": 4205,
	"./03.png": 9866,
	"./04.png": 1764,
	"./05.png": 7919,
	"./1.png": 8926,
	"./2.png": 6138,
	"./3.png": 3020,
	"./4.png": 9705,
	"./5.png": 1818,
	"./6.png": 5456,
	"./address.png": 8015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9730;